import React from 'react'

export const IconCircleError = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <circle cx="11" cy="11" r="9" fill="currentColor" />
    <path
      d="M14 8L8 14"
      stroke="#FFFF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8L14 14"
      stroke="#FFFF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
